/**
 * @owner @Appboy/core-objects
 * @fileoverview GET handler for the "/app_settings/get_custom_event_properties" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appSettingsGetCustomEventProperties } from "./constants";
import type { AppSettingsGetCustomEventPropertiesResult, EventPropertyProps } from "./types";

export const getAppSettingsGetCustomEventProperties = reactQueryFetcherAdapter(
  appSettingsGetCustomEventProperties,
  (signal: AbortSignal, props: EventPropertyProps): Promise<AppSettingsGetCustomEventPropertiesResult> => {
    return fetch("/app_settings/get_custom_event_properties", "GET", props, { signal });
  }
);
